<template>
  <div class="d-flex justify-content-end align-items-center mb-2">
    <VuePaginate
      :model-value="modelValue"
      :click-handler="onChange"
      :page-count="pageCount"
      prev-text="‹"
      next-text="›"
      container-class="pagination mb-0"
      page-class="page-item"
      page-link-class="page-link"
      active-class="page-item active"
      prev-class="page-item"
      prev-link-class="page-link"
      next-class="page-item"
      next-link-class="page-link"
      @update:model-value="emit('update:modelValue', $event)"
    />
    <ul v-if="showGo" class="pagination mb-0 ms-3">
      <li class="page-item">
        <input
          v-model.number="jump"
          type="number"
          :min="1"
          :max="pageCount"
          class="page-link text-center page-jump-input"
          @keydown.enter="go"
        />
      </li>
      <li class="page-item">
        <button class="page-link fw-normal" @click="go">Go</button>
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
import { ref, watch } from "vue";
import { VuePaginate } from "@svifty7/vue-paginate";

const props = defineProps<{
  modelValue: number;
  pageCount: number;
  showGo?: boolean;
}>();

const emit = defineEmits<{
  (e: "update:modelValue", v: number): void;
  (e: "change", v: number): void;
}>();

function onChange(page: number) {
  emit("change", page);
}

const jump = ref<number>(props.modelValue || 1);
watch(
  () => props.modelValue,
  (v) => (jump.value = v || 1),
);

function go() {
  let p = Math.floor(jump.value || 1);
  if (p < 1) p = 1;
  if (p > props.pageCount) p = props.pageCount;
  emit("update:modelValue", p);
  emit("change", p);
}
</script>

<style scoped>
.page-jump-input {
  width: 70px;
}
.page-link {
  color: #626773;
}
.pagination + .pagination {
  margin-left: 0.75rem;
}
</style>
